import * as api from '../api/client/backendclient'
import { openWebSocket } from '../api/client/websocketclient'
import { jsError } from '../common/utils'

//import { router } from "../router";

const loginSucceeded = (data) => {
	// decode additional eSalary data from access token and include the tokens themselves
	const auth = { ...decodeToken(data.access_token), ...data }

	if ((auth.role === 'EMPLOYEE' || (Object.keys(auth.roles).length === 1 && auth.roles.up)) && auth.employeeNumber) {
		auth.personalProfile = true
	}

	//router.navigate("/dashboard");

	return {
		type: 'LOGIN_SUCCEEDED',
		payload: {
			auth,
		},
	}
}

const loginError = (error) => ({
	type: 'LOGIN_ERROR',
	payload: {
		error: error.response ? error.response.data : error.message || null,
	},
})

export const postLogin =
	({ username, password, code }) =>
	(dispatch) => {
		dispatch({ type: 'LOGIN_LOADING' })
		api
			.postLogin(username, password, code)
			.then((resp) => {
				const { status } = resp.data
				if (status === 'MFA_REQUIRED') {
					dispatch({ type: status, payload: { auth: { mfaRequired: true } } })
				} else {
					dispatch(loginSucceeded(resp.data))
					openWebSocket()
				}
			})
			.catch((error) => {
				jsError('Login failed', error.message)
				dispatch(loginError(error))
			})
	}

export const postRefresh = (refresh_token) => (dispatch) => {
	dispatch({ type: 'LOGIN_LOADING' })
	api
		.postRefresh(refresh_token)
		.then((resp) => {
			dispatch(loginSucceeded(resp.data))
			openWebSocket()
		})
		.catch((error) => {
			jsError('Refresh failed', error.message)
			//dispatch(loginError(error));
			dispatch({ type: 'LOGOUT_SUCCEEDED' })
		})
}

export const postLogout = () => (dispatch) => {
	dispatch({ type: 'LOGOUT_SUCCEEDED' })
}

/*
const connectionError = error => ({
  type: "ERROR",
  payload: {
    status: error.response ? error.response.status : null,
    headers: error.response ? error.response.headers : null,
    data: error.response ? error.response.data : null,
    message: error.message,
  },
});
*/

// convert roles array to Object with role names as keys
const reviveRoles = (json) => {
	if (Array.isArray(json.roles)) {
		//json.roles = new Set(json.roles); // Redux state does not support non-serializable values

		const roles = {}
		for (const role of json.roles) {
			//if (role === "up") continue; // not used in HR
			roles[role] = true
		}

		// priority order hrAdmin > supervisor > equipmentManager ?
		const supervisor = !roles.hrAdmin && roles.supervisor
		if (supervisor) roles.supervisor = supervisor

		const equipmentManager = !roles.hrAdmin && roles.equipmentManager
		if (equipmentManager) roles.equipmentManager = equipmentManager

		json.roles = roles
	}

	return json
}

const base64ToBytes = (base64) => Uint8Array.from(atob(base64), (m) => m.codePointAt(0))
// Decodes additional data part of a JWT token to a JS object
const decodeToken = (token) => {
	const json = JSON.parse(new TextDecoder().decode(base64ToBytes(token.match(/\.([^.]+)/)[1])))
	return reviveRoles(json)
}
